// import { error_toast } from "Components/Toast/toasts";

export const getErrorMessageAndCode = (error) => {
  const { code, message } = error.response.data;
  // error_toast(message)
  return { code, message };
};
